module.exports = __webpack_public_path__ + "static/img/sy7.5e229295.png";